// src/context/SucursalContext.js
import React, { createContext, useState, useContext } from 'react';
import { normalizeDataObject } from '../utils/normalizationUtils';

const SucursalContext = createContext();

export const SucursalProvider = ({ children }) => {
  // Inicializar con valores del localStorage si existen
  const [selectedSucursal, setSelectedSucursal] = useState(() => {
    try {
      const saved = localStorage.getItem('revvly_sucursal_selected');
      return saved || '';
    } catch {
      return '';
    }
  });
  
  const [sucursalData, setSucursalData] = useState(() => {
    try {
      const saved = localStorage.getItem('revvly_sucursal_data');
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });
  
  // NUEVO: Cache de todas las sucursales cargadas por el Sidebar
  const [sucursalesCache, setSucursalesCache] = useState([]);
  const [sucursalesCacheTimestamp, setSucursalesCacheTimestamp] = useState(null);
  
  // Función para establecer tanto el ID como los datos de la sucursal
  const setSucursal = (id, data) => {
    console.log('🏪 [SucursalContext] setSucursal called:', { id, nombre: data?.Nombre || data?.nombre });
    setSelectedSucursal(id);
    
    // Normalizar datos de sucursal
    const normalizedData = data ? normalizeDataObject(data, 'sucursal') : null;
    setSucursalData(normalizedData);
    
    // Persistir en localStorage
    try {
      if (id) {
        localStorage.setItem('revvly_sucursal_selected', id);
      } else {
        localStorage.removeItem('revvly_sucursal_selected');
      }
      
      if (normalizedData) {
        localStorage.setItem('revvly_sucursal_data', JSON.stringify(normalizedData));
      } else {
        localStorage.removeItem('revvly_sucursal_data');
      }
    } catch (error) {
      console.warn('No se pudo guardar sucursal en localStorage:', error);
    }
    
    console.log('✅ [SucursalContext] Sucursal establecida:', { selectedId: id, normalizedData: normalizedData?.Nombre || normalizedData?.nombre });
  };
  
  // Función normalizada para establecer datos de sucursal directamente
  const setSucursalDataNormalized = (data) => {
    const normalizedData = data ? normalizeDataObject(data, 'sucursal') : null;
    setSucursalData(normalizedData);
  };
  
  // NUEVO: Función para que el Sidebar actualice el cache de sucursales
  const updateSucursalesCache = (sucursales) => {
    // Normalizar array de sucursales
    const normalizedSucursales = sucursales ? normalizeDataObject(sucursales, 'sucursales') : [];
    setSucursalesCache(normalizedSucursales);
    setSucursalesCacheTimestamp(Date.now());
  };
  
  // NUEVO: Función para obtener sucursales desde el cache (para otros componentes)
  const getSucursalesFromCache = () => {
    return sucursalesCache;
  };
  
  // NUEVO: Función para verificar si el cache es válido (5 minutos)
  const isCacheValid = () => {
    if (!sucursalesCacheTimestamp) return false;
    const age = Date.now() - sucursalesCacheTimestamp;
    return age < 300000; // 5 minutos
  };
  
  // NUEVO: Función para limpiar el cache (cuando cambia empresa)
  const clearSucursalesCache = () => {
    setSucursalesCache([]);
    setSucursalesCacheTimestamp(null);
  };
  
  return (
    <SucursalContext.Provider value={{ 
      selectedSucursal, 
      setSelectedSucursal, 
      sucursalData, 
      setSucursalData,
      setSucursalDataNormalized,
      setSucursal,
      
      // Nuevas funciones de cache
      sucursalesCache,
      updateSucursalesCache,
      getSucursalesFromCache,
      isCacheValid,
      clearSucursalesCache,
      sucursalesCacheTimestamp
    }}>
      {children}
    </SucursalContext.Provider>
  );
};

export const useSucursal = () => {
  //console.log('🏪 useSucursal called - timestamp:', new Date().toLocaleTimeString());
  return useContext(SucursalContext);
};